/*!
 * devextreme-angular
 * Version: 24.2.7
 * Build date: Mon Apr 28 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    OnInit,
    OnDestroy,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import { dxFileManagerDetailsColumn, FileManagerItemViewMode } from 'devextreme/ui/file_manager';

import {
    NestedOptionHost,
} from 'devextreme-angular/core';
import { NestedOption } from 'devextreme-angular/core';


@Component({
    selector: 'dxo-file-manager-item-view',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoFileManagerItemViewComponent extends NestedOption implements OnDestroy, OnInit  {
    @Input()
    get details(): { columns?: Array<dxFileManagerDetailsColumn | string> } {
        return this._getOption('details');
    }
    set details(value: { columns?: Array<dxFileManagerDetailsColumn | string> }) {
        this._setOption('details', value);
    }

    @Input()
    get mode(): FileManagerItemViewMode {
        return this._getOption('mode');
    }
    set mode(value: FileManagerItemViewMode) {
        this._setOption('mode', value);
    }

    @Input()
    get showFolders(): boolean {
        return this._getOption('showFolders');
    }
    set showFolders(value: boolean) {
        this._setOption('showFolders', value);
    }

    @Input()
    get showParentFolder(): boolean {
        return this._getOption('showParentFolder');
    }
    set showParentFolder(value: boolean) {
        this._setOption('showParentFolder', value);
    }


    protected get _optionPath() {
        return 'itemView';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }


    ngOnInit() {
        this._addRecreatedComponent();
    }

    ngOnDestroy() {
        this._addRemovedOption(this._getOptionPath());
    }


}

@NgModule({
  declarations: [
    DxoFileManagerItemViewComponent
  ],
  exports: [
    DxoFileManagerItemViewComponent
  ],
})
export class DxoFileManagerItemViewModule { }
